import React, { useState } from "react";
import { Row, Column, FormGroup, TextArea } from "carbon-components-react";

const MarketAnalysisForm = ({ disabled, register, errors, isJury }) => {
  return (
    <FormGroup legendText="5	ANÁLISE DO MERCADO" className="section-header">
      <h6 className="section-subtitle">
        A ser preenchida por todos/as candidatos/as independentemente se tem ou
        não um negócio actualmente.
      </h6>
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="mainProblemsIntendToSolve"
              labelText="5.1 Quais são os principais problemas que o(s) seu(s) produto(s)/ serviço(s) pretende(m) solucionar? "
              rows={5}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 150 palavras.]"
              {...register("mainProblemsIntendToSolve")}
            />
            <p className="field-error">
              {errors.mainProblemsIntendToSolve?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      {!isJury && (
        <fieldset fieldset className="bx--fieldset">
          <Row>
            <Column xsm={12} sm={12} md={12} lg={12} className="required">
              <TextArea
                id="solutionsForEachProblem"
                labelText="5.2 Descreva possíveis soluções para cada problema identificado."
                rows={5}
                enableCounter
                disabled={disabled}
                helperText="[Use no máximo 150 palavras.]"
                {...register("solutionsForEachProblem")}
              />
              <p className="field-error">
                {errors.solutionsForEachProblem?.message}
              </p>
            </Column>
          </Row>
        </fieldset>
      )}
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="mainGroupsOfCustomers"
              labelText="5.3 Identifique os principais grupos de clientes com as mesmas características (segmentos) que pretende servir."
              rows={5}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 150 palavras.]"
              {...register("mainGroupsOfCustomers")}
            />
            <p className="field-error">
              {errors.mainGroupsOfCustomers?.message}
            </p>
          </Column>
        </Row>
      </fieldset>
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="promotionStrategy"
              labelText="5.4 Que estratégia de promoção  para atrair e comunicar sobre a marca ao grupo-alvo pretende adotar?"
              rows={5}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("promotionStrategy")}
            />
            <p className="field-error">{errors.promotionStrategy?.message}</p>
          </Column>
        </Row>
      </fieldset>
      <fieldset fieldset className="bx--fieldset">
        <Row>
          <Column xsm={12} sm={12} md={12} lg={12} className="required">
            <TextArea
              id="locations"
              labelText="5.5 Indique onde (locais) e como (meios) os seu(s) produto(s) ou serviço(s) estarão disponíveis bem como as vantagens da referida localização."
              rows={5}
              enableCounter
              disabled={disabled}
              helperText="[Use no máximo 100 palavras.]"
              {...register("locations")}
            />
            <p className="field-error">{errors.locations?.message}</p>
          </Column>
        </Row>
      </fieldset>
      {!isJury && (
        <fieldset fieldset className="bx--fieldset">
          <Row>
            <Column xsm={12} sm={12} md={12} lg={12} className="required">
              <TextArea
                id="priceStrategy"
                labelText="5.6 Indique qual será a sua estratégia no estabelecimento de preços de venda para o(s) seu(s) produto(s) ou serviço(s). Liste as vantagens da sua estratégia."
                rows={5}
                enableCounter
                disabled={disabled}
                helperText="[Use no máximo 100 palavras.]"
                {...register("priceStrategy")}
              />
              <p className="field-error">{errors.priceStrategy?.message}</p>
            </Column>
          </Row>
        </fieldset>
      )}
      {!isJury && (
        <fieldset fieldset className="bx--fieldset">
          <Row>
            <Column xsm={12} sm={12} md={12} lg={12} className="required">
              <TextArea
                id="typeOfCompetitor"
                labelText="5.7 Identifique o tipo de concorrente, a localização em relação ao seu negócio e a vantagem competitiva que possuem."
                rows={5}
                enableCounter
                disabled={disabled}
                helperText="[Use no máximo 100 palavras.]"
                {...register("typeOfCompetitor")}
              />
              <p className="field-error">{errors.typeOfCompetitor?.message}</p>
            </Column>
          </Row>
        </fieldset>
      )}
    </FormGroup>
  );
};

MarketAnalysisForm.defaultProps = {
  disabled: false,
};
export default MarketAnalysisForm;
